import styled from 'styled-components';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../CommonComponents/OPL/Box/Box';

export const ListTerm = styled(Text).attrs({ as: 'dt' })(({ theme }) => ({
  fontWeight: 500,
  padding: 24,
  borderBottom: `1px solid ${theme.colors.neutral[200]}`,
}));

export const ListDefinition = styled(Text).attrs({ as: 'dd' })(({ theme }) => ({
  fontWeight: 500,
  padding: 24,
  borderBottom: `1px solid ${theme.colors.neutral[200]}`,
}));

export const List = styled(Box).attrs({ as: 'dl' })({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
});

export const ListHeader = styled(Text)(({ theme }) => ({
  padding: 24,
  borderBottom: `1px solid ${theme.colors.neutral[200]}`,
  fontSize: theme.fontSizes.h6,
  fontWeight: 600,
}));

export const ListSubHeader = styled(Text)(({ theme }) => ({
  padding: 24,
  borderBottom: `1px solid ${theme.colors.neutral[200]}`,
  fontWeight: 600,
}));
